import { feetInchRegex } from "../constants/regex";
import {
  primarySleeperBodyTypeSelector,
  primarySleeperEvrScoreSelector,
  primarySleeperFirmnessSelector,
  primarySleeperHeightSelector,
  primarySleeperWeightSelector,
  primarySleeperPrimarySleepStyleSelector,
  secondarySleeperBodyTypeSelector,
  secondarySleeperEvrScoreSelector,
  secondarySleeperFirmnessSelector,
  secondarySleeperPrimarySleepStyleSelector,
  secondarySleeperHeightSelector,
  secondarySleeperWeightSelector,
  setPrimarySleeperFinalEvrScore,
  setSecondarySleeperFinalEvrScore
} from "../redux/slices/mattressConfiguration";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

export const weightRangeInKg = [
  0, 45.36, 54.43, 63.5, 72.57, 81.65, 90.71, 99.79, 108.86, 117.93, 127,
  136.07,
];
export const heightRangeInCm = [0, 152.4, 160, 167.64, 175.26, 182.88, 190.5, 198.12];

export const evrScoreMatrix = [
  [22, 22, 33, 34, 34, 44, 44, 55, 55, 55, 56, 56],
  [22, 22, 23, 33, 33, 44, 44, 45, 55, 55, 56, 56],
  [22, 22, 23, 33, 33, 34, 34, 45, 55, 55, 55, 56],
  [22, 12, 22, 23, 23, 33, 34, 44, 45, 55, 55, 55],
  [12, 12, 22, 22, 23, 33, 33, 44, 44, 45, 45, 45],
  [12, 12, 12, 22, 22, 23, 33, 34, 44, 45, 45, 45],
  [12, 12, 12, 12, 22, 23, 33, 34, 44, 45, 45, 45],
  [12, 12, 12, 12, 12, 22, 23, 33, 34, 44, 45, 45],
];

export const firmnessValues = [12, 22, 23, 33, 34, 44, 45, 55, 56];

export const getEvrScore = (weight, height) => {
  let heightCM = height;
  let weightKG = weight;
  if (height.includes('"')) {
    heightCM = parseFeetInchToCm(height);
    weightKG = convertLbsToKg(weight);
  }
  const heightIndex = getRangeIndex(heightRangeInCm, heightCM);
  const weightIndex = getRangeIndex(weightRangeInKg, weightKG);
  console.log("heightindex: " + heightIndex);
  console.log(height);
  return evrScoreMatrix[heightIndex][weightIndex];
};

const getRangeIndex = (array, value) => {
  let finalIndex;
  array.map((element, index) => {
    if (index !== array.length - 1) {
      if (value >= element && value <= array[index + 1]) {
        return (finalIndex = index);
      }
    } else if (index === array.length - 1 && finalIndex === undefined) {
      return (finalIndex = index);
    }
  });
  return finalIndex;
};

export const parseFeetInchToCm = height => {
  const { feet, inch } = parseFeetAndInch(height);
  const heightInInch = feet * 12 + inch;
  return (heightInInch * 2.54).toFixed(2);
};

export const parseFeetAndInch = feetInchString => {
  const rex = feetInchRegex;
  let feetInchCorrectString = feetInchString.replace(/ /g, '');
  if (feetInchString.slice(-1) !== '"') {
    feetInchCorrectString = feetInchCorrectString + '"';
  }
  const match = rex.exec(feetInchCorrectString);
  let feet = null;
  let inch = null;
  if (match) {
    feet = parseInt(match[1], 10);
    inch = parseInt(match[2], 10);
  }
  return { feet, inch };
};

export const convertLbsToKg = weightInLBS => {
  return (weightInLBS * 0.45359237).toFixed(2);
};

export const getBodyTypeAdjustmentValue = bodyType => {
  if (bodyType === 1) {
    return -1;
  } else if (bodyType === 2) {
    return -1;
  }
  return 0;
};

export const getSleepPositionsAdjustmentValue = sleepPosition => {
  if (sleepPosition === 1) {
    return 1;
  } else if (sleepPosition === 2) {
    return 2;
  }
  return 0;
};

export const getFirmnessAdjustmentValue = firmness => {
  const index = firmness - 1;
  const adjustmentValues = [-2, -1, 0, 1, 2, 2];
  return adjustmentValues[index];
};

export const getFinalEvrScore = ({ isPrimarySleeper }) => {
  console.log("isPrimarySleeper: " + isPrimarySleeper);

  // Get basic evrscore based on height and weight
  let finalEvrScore;
  let bodyType;
  let sleepPosition;
  let firmness;

  const primarySleeperFinalEvrScore = useSelector(setPrimarySleeperFinalEvrScore);
  const secondarySleeperFinalEvrScore = useSelector(setSecondarySleeperFinalEvrScore);
  const dispatch = useDispatch();

  if (isPrimarySleeper) {
    //Assign evrscore
    finalEvrScore = getEvrScore(useSelector(primarySleeperWeightSelector), useSelector(primarySleeperHeightSelector));
    //Assign bodyType
    bodyType = useSelector(primarySleeperBodyTypeSelector);

    //Assign sleep position
    sleepPosition = useSelector(primarySleeperPrimarySleepStyleSelector);

    //Assign firmness
    firmness = useSelector(primarySleeperFirmnessSelector);

  } else {
    //Assign evrscore
    finalEvrScore = getEvrScore(useSelector(secondarySleeperWeightSelector), useSelector(secondarySleeperHeightSelector));
    //Assign bodyType
    bodyType = useSelector(secondarySleeperBodyTypeSelector);
    //Assign sleep position
    sleepPosition = useSelector(secondarySleeperPrimarySleepStyleSelector);
    //Assign firmness
    firmness = useSelector(secondarySleeperFirmnessSelector);
  }


  bodyType = bodyType ? bodyType : 0;
  sleepPosition = sleepPosition ? sleepPosition : 0;
  firmness = firmness ? firmness : 0;
  finalEvrScore = finalEvrScore ? finalEvrScore : 0;
  if (finalEvrScore < 12) finalEvrScore = 12;
  if (finalEvrScore > 56) finalEvrScore = 56;

  let index = firmnessValues.indexOf(finalEvrScore);

  // Body Type
  index += getBodyTypeAdjustmentValue(bodyType);
  if (index < 0) index = 0;
  // Sleep Positions
  index += getSleepPositionsAdjustmentValue(sleepPosition);
  if (index < 0) index = 0;
  // Pain Points ???

  // Firmness
  index += getFirmnessAdjustmentValue(firmness);
  if (index < 0) index = 0;

  finalEvrScore = firmnessValues[index];
  if (isNaN(finalEvrScore)) {
    if (index < 0) finalEvrScore = 12;
    if (index > 8) finalEvrScore = 56;
  }

  if (finalEvrScore < 12) finalEvrScore = 12;
  if (finalEvrScore > 56) finalEvrScore = 56;

  if (isPrimarySleeper) {
    dispatch(setPrimarySleeperFinalEvrScore(finalEvrScore));
  } else {
    dispatch(setSecondarySleeperFinalEvrScore(finalEvrScore));
  }

  return finalEvrScore;
};
